import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import styles from '../IssueOfSharesView.module.scss';
import Buttonstyles from 'common/components/PrimaryButtonComponent/PrimaryButtonComponent.module.scss';
import {
  LOAD_STATES,
  FORM_SUCCESS_MESSAGE_TIMEOUT
} from 'common/consts/common';
import ContactFormService from 'services/SharesContactForm.service';
import Bind from 'lodash-decorators/bind';
import ContentStore from 'stores/Content.store';
import messages from '../IssueOfSharesView.intl';

@injectIntl
@observer
export default class ContactForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      checkboxProcessing: false,
      checkboxSending: false,
      buttonState: '',
      showError: false
    };
  }

  resetState() {
    this.setState({
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      checkboxProcessing: false,
      checkboxSending: false,
      buttonState: '',
      showError: false
    });
  }

  @Bind
  createMarkup(val) {
    return { __html: val };
  }

  @Bind()
  updateInputValue(event) {
    const { id, type, checked, value: inputValue } = event.target;
    const value = type === 'checkbox' ? checked : inputValue;
    const currentState = this.state;
    currentState[id] = value;

    if (
      type === 'checkbox' &&
      checked &&
      (this.state.checkboxProcessing && this.state.checkboxSending)
    ) {
      currentState.showError = false;
    } else if (type === 'checkbox' && !checked) {
      currentState.showError = true;
    }

    this.setState && this.setState(currentState);
  }

  @Bind()
  async submitForm(event) {
    event.preventDefault();
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      checkboxProcessing,
      checkboxSending
    } = this.state;
    if (checkboxProcessing && checkboxSending) {
      this.setState({
        ...this.state,
        buttonState: LOAD_STATES.LOADING
      });
      try {
        await ContactFormService.sendContactForm(
          firstName,
          lastName,
          email,
          phoneNumber
        );
        this.setState({
          ...this.state,
          buttonState: LOAD_STATES.SUCCESS
        });

        setTimeout(() => {
          this.resetState();
        }, FORM_SUCCESS_MESSAGE_TIMEOUT);
      } catch (e) {
        this.setState({
          ...this.state,
          buttonState: LOAD_STATES.ERROR
        });
      }
    } else {
      this.setState({
        ...this.state,
        showError: true
      });
    }
  }

  render() {
    const content = ContentStore.content.IssueOfShares;
    const {
      contactFormTitle,
      contactFormSubtitle,
      contactFormPocessingAcceptance,
      contactFormSendingAcceptance
    } = content;

    return (
      <form className={styles.ContactForm} onSubmit={this.submitForm}>
        <h2
          dangerouslySetInnerHTML={this.createMarkup(contactFormTitle)}
          htmlFor="email"
        />
        <h3 dangerouslySetInnerHTML={this.createMarkup(contactFormSubtitle)} />
        <input
          className={styles.ContactFormInput}
          id="firstName"
          placeholder={this.props.intl.formatMessage(
            messages.contactFormFirstName
          )}
          type="text"
          onChange={this.updateInputValue}
          value={this.state.firstName ? this.state.firstName : ''}
          required
        />
        <input
          className={styles.ContactFormInput}
          id="lastName"
          placeholder={this.props.intl.formatMessage(
            messages.contactFormLastName
          )}
          type="text"
          onChange={this.updateInputValue}
          value={this.state.lastName ? this.state.lastName : ''}
          required
        />
        <input
          className={styles.ContactFormInput}
          id="email"
          placeholder={this.props.intl.formatMessage(messages.contactFormEmail)}
          type="text"
          onChange={this.updateInputValue}
          value={this.state.email ? this.state.email : ''}
          required
        />
        <input
          className={styles.ContactFormInput}
          id="phoneNumber"
          placeholder={this.props.intl.formatMessage(
            messages.contactFormPhoneNumber
          )}
          type="text"
          onChange={this.updateInputValue}
          value={this.state.phoneNumber ? this.state.phoneNumber : ''}
        />
        <div className={styles.ContactFormCheckboxWrapper}>
          <input
            className={styles.input}
            type="checkbox"
            id="checkboxProcessing"
            onChange={this.updateInputValue}
            checked={this.state.checkboxProcessing}
          />
          <label className={styles.checkbox} htmlFor="checkboxProcessing">
            <div />
          </label>
          <label
            className={styles.label}
            htmlFor="checkboxProcessing"
            checkbox={this.state.checkboxProcessing}
            dangerouslySetInnerHTML={this.createMarkup(
              contactFormPocessingAcceptance
            )}
          />
        </div>
        <div className={styles.ContactFormCheckboxWrapper}>
          <input
            className={styles.input}
            type="checkbox"
            id="checkboxSending"
            onChange={this.updateInputValue}
            checked={this.state.checkboxSending}
          />
          <label className={styles.checkbox} htmlFor="checkboxSending">
            <div />
          </label>
          <label
            className={styles.label}
            htmlFor="checkboxSending"
            checkbox={this.state.checkboxSending}
            dangerouslySetInnerHTML={this.createMarkup(
              contactFormSendingAcceptance
            )}
          />
        </div>
        {this.state.showError ? (
          <p className={styles.errorMsg}>
            {this.props.intl.formatMessage(messages.contactFormWarning)}
          </p>
        ) : (
          <br />
        )}
        <div className={styles.ButtonWrapper}>
          <button
            type="submit"
            className={`
            ${Buttonstyles.PrimaryButtonComponent}
            ${styles.FillingButton}
          `}
          >
            {this.state.buttonState === LOAD_STATES.LOADING
              ? this.props.intl.formatMessage(messages.contactFormLoading)
              : this.state.buttonState === LOAD_STATES.SUCCESS
                ? this.props.intl.formatMessage(
                    messages.contactFormMessageSuccess
                  )
                : this.props.intl.formatMessage(messages.contactFormButton)}
          </button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/IssueOfShares/components/ContactForm.js